module.exports = __webpack_public_path__ + "pc/media/mov_bbb.198918f4.mp4";